import Meetings from './container';

export default Meetings;
